import * as Factory from 'factory.ts'
import faker from 'faker'

import { type VendorApprovalGroup } from '@webapp/models/VendorApprovalGroup'
import { VendorApproverMock } from './approver.mock'

export const VendorApprovalGroupMock =
  Factory.Sync.makeFactory<VendorApprovalGroup>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.random.word()),
    approvers: Factory.each(() => VendorApproverMock.buildList(2)),
  })
